const groupCreateButtonModalEquipService = {
  text: 'Create Section +'
};

export default groupCreateButtonModalEquipService;
